import styled from 'styled-components'
import * as spacing from 'styles/spacing'
import { mediaDown } from '../../../styles/media'

import { buttonBackColor } from 'styles/colors'

export const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 25px;
  z-index: 450;
  padding: ${spacing.medium};
  display: flex;
`

export const PreviewContainer = styled.div`
  width: 100vw;

  height: 100vh;

  display: flex;

  justify-content: center;

  align-items: center;

  flex-direction: column;

  background-color: #000;
`

export const PreviewWrapper = styled.div`
  width: 80%;

  max-height: 80vh;

  object-fit: contain;

  border-radius: 10px;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  border-radius: 30px;
  background-color: aliceblue;
  padding: 5%;
`

export const ActionButtonWrapper = styled.div`
  margin-top: 3%;
  width: 90%;
  display: flex;
  align-items: center;
  justify-content: center;

  ${mediaDown.large`margin-top:15%;`};
`
export const ButtonContainer = styled.div`
  width: 100%;
`

export const DataWrap = styled.div`
  width: 100%;
  display: flex;
  justify-content: right;
  margin: 10px;
  margin: 10px;
  h2 {
    width: 50%;
    color: #black;
  }
  .keyName {
    text-align: left;
    width: 30%;
  }
`

export const Header = styled.h1`
  color: ${buttonBackColor};
  text-align: center;
  padding: 10px;
  margin-bottom: 5px;
`
